import { pageUrl, coverThumbUrl } from "@/lib/appresse";

const OFFLINE_CACHE = "appresse-offline-v1";
const COVER_CACHE = "appresse-cover-v1";
const REG_KEY = "appresse_offline_editions";

const pathOnly = (u) => {
  try { const x = new URL(u); return x.origin + x.pathname; } catch { return u; }
};

export function getOfflineList() {
  try { return JSON.parse(localStorage.getItem(REG_KEY) || "[]"); } catch { return []; }
}
function saveList(list) {
  localStorage.setItem(REG_KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("appresse:offline-changed"));
}
export function isSaved(id) { return getOfflineList().some((e) => e.id === id); }

// Download all page images (+ cover) of an edition for offline reading.
export async function downloadEdition(edition, onProgress) {
  if (!("caches" in window)) throw new Error("Stockage hors-ligne non supporté par ce navigateur");
  const cache = await caches.open(OFFLINE_CACHE);
  const pages = edition.pages || 0;

  // Cover thumbnail (for the offline library list).
  try {
    const cu = coverThumbUrl(edition.id);
    const cr = await fetch(cu);
    if (cr.ok) {
      cache.put(pathOnly(cu), cr.clone()).catch(() => {});
      (await caches.open(COVER_CACHE)).put(cu, cr).catch(() => {});
    }
  } catch { /* ignore cover errors */ }

  for (let n = 1; n <= pages; n++) {
    const u = pageUrl(edition.id, n);
    try {
      const resp = await fetch(u);
      if (resp.ok) await cache.put(pathOnly(u), resp.clone());
    } catch { /* skip failed page */ }
    onProgress?.(n, pages);
  }

  const meta = {
    id: edition.id, title: edition.title, category: edition.category,
    publication_date: edition.publication_date, pages, saved_at: Date.now(),
  };
  const list = getOfflineList().filter((e) => e.id !== edition.id);
  list.unshift(meta);
  saveList(list);
  return meta;
}

export async function removeEdition(id) {
  try {
    const cache = await caches.open(OFFLINE_CACHE);
    const keys = await cache.keys();
    await Promise.all(
      keys.filter((req) => req.url.includes(`/editions/${id}/`)).map((req) => cache.delete(req))
    );
  } catch { /* ignore */ }
  saveList(getOfflineList().filter((e) => e.id !== id));
}

// Approximate storage used by the app (MB).
export async function offlineUsageMB() {
  try {
    if (navigator.storage?.estimate) {
      const e = await navigator.storage.estimate();
      return Math.round(((e.usage || 0) / (1024 * 1024)) * 10) / 10;
    }
  } catch { /* ignore */ }
  return null;
}
